/** @jsx jsx */
import { css, jsx } from '@emotion/react';

type Props = {
  color?: string;
  padding?: '--cds-spacing-50' | '--cds-spacing-100';
};

const styles = {
  dot: (color?: string, padding = '--cds-spacing-100') => css`
    padding: 0 var(${padding});
    color: ${color ?? 'inherit'};
  `,
};

/**
 * A visual dot separator between content items.
 * The dot is hidden from screen readers via aria-hidden.
 * Parent components are responsible for providing clear SR text
 * (e.g. via VisuallyHidden + aria-hidden on the visual content).
 */
const DottedSeparator = ({ color, padding }: Props) => {
  return (
    <span aria-hidden="true" css={styles.dot(color, padding)}>
      &#x2022;
    </span>
  );
};

export default DottedSeparator;
